import { UseMutationOptions } from '@tanstack/react-query';

import useMutation from 'hooks/useMutation';
import { ApiMethods, CuredApiPaths } from 'models/enums';

import MutationKeys from './keys';

type UnarchiveCampaignInput = {
    id: string;
};

const useUnarchiveCampaign = (mutateOptions?: UseMutationOptions<unknown, Error, UnarchiveCampaignInput>) =>
    useMutation<UnarchiveCampaignInput>(
        MutationKeys.UNARCHIVE_CAMPAIGN,
        CuredApiPaths.CAMPAIGNS_UNARCHIVE,
        mutateOptions,
        ApiMethods.POST
    );

export default useUnarchiveCampaign;
